module.exports = __webpack_public_path__ + "media/images/green-bg-plain-c54faf92.jpg";